// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"EditGymSettings_formContainer__1Vvha","classConfigContainer":"EditGymSettings_classConfigContainer__1oH-8"};